import { render, staticRenderFns } from "./Labs.vue?vue&type=template&id=89dc264a&"
import script from "./Labs.vue?vue&type=script&lang=js&"
export * from "./Labs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports